<template>
  <main>
    <aside :class="['sidebar', { close: !sidebarOpen }]">
      <div class="sidebar-icon" @click="toggleSidebar">
        <div class="barr1" />
        <div class="barr2" />
        <div class="barr3" />
      </div>
      <div class="sidebar-icon close" @click="toggleSidebar">
        <div class="barr1" />
        <div class="barr2" />
        <div class="barr3" />
      </div>

      <ul class="sidebar-menu-set">
        <router-link to="/front/profil">
          <div :class="['sidebar-menu-animate', { active: isActiveRoute('/front/profil') }]">
            <li :class="['sidebar-menu', { active: isActiveRoute('/front/profil') }]">
              <img src="/public/icons/icon-profil.svg" class="sidebar-menu-icon" alt="" />
              <span>Mon profil</span>
              <div class="my-badge br2 dot bg-color-notif" />
            </li>
          </div>
        </router-link>
        <router-link to="/front/profil/informations-personnelles">
          <div :class="['sidebar-menu-animate', { active: isActiveRoute('/front/profil/informations-personnelles') }]">
            <li :class="['sidebar-menu', { active: isActiveRoute('/front/profil/informations-personnelles') }]">
              <img src="/public/icons/icon-info-perso.svg" class="sidebar-menu-icon" alt="" />
              <span>Informations personnelles</span>
              <div class="my-badge br2 dot bg-color-notif" />
            </li>
          </div>
        </router-link>
        <router-link v-if="!isGerant" to="/front/profil/ma-souscription">
          <div :class="['sidebar-menu-animate', { active: isActiveRoute('/front/profil/ma-souscription') }]">
            <li :class="['sidebar-menu', { active: isActiveRoute('/front/profil/ma-souscription') }]">
              <img src="/public/icons/icon-souscription.svg" class="sidebar-menu-icon" alt="" />
              <span>Ma souscription</span>
              <div class="my-badge br2 dot bg-color-notif" />
            </li>
          </div>
        </router-link>
        <router-link v-if="!isGerant" to="/front/profil/pouvoir-achat">
          <div :class="['sidebar-menu-animate', { active: isActiveRoute('/front/profil/pouvoir-achat') }]">
            <li :class="['sidebar-menu', { active: isActiveRoute('/front/profil/pouvoir-achat') }]">
              <img src="/public/icons/icon-pouvoir.svg" class="sidebar-menu-icon" alt="" />
              <span>Pouvoir d'achat</span>
              <div class="my-badge br2 dot bg-color-notif" />
            </li>
          </div>
        </router-link>
        <router-link v-if="!isGerant" to="/front/profil/plan-mensuel">
          <div :class="['sidebar-menu-animate', { active: isActiveRoute('/front/profil/plan-mensuel') }]">
            <li :class="['sidebar-menu', { active: isActiveRoute('/front/profil/plan-mensuel') }]">
              <img src="/public/icons/icon-plan.svg" class="sidebar-menu-icon" alt="" />
              <span>Plan mensuel</span>
              <div class="my-badge br2 dot bg-color-notif" />
            </li>
          </div>
        </router-link>
        <a @click="handleLogout" style="cursor: pointer;">
          <div class="sidebar-menu-animate">
            <li class="sidebar-menu">
              <img src="/public/icons/icon-logout.svg" class="sidebar-menu-icon icon-neutral" alt="" />
              <span>Déconnexion</span>
              <div class="my-badge br2 dot bg-color-notif" />
            </li>
          </div>
        </a>
        <div class="clear-both h-0" />
      </ul>

      <div v-if="!isGerant" class="sidebar-top px-3">
        <div class="widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6">
          <div class="flex align-items-center gap-4 mb-3">
            <img src="/public/icons/icon-souscription.svg" class="size-base icon-neutral" alt="" />
            <h4 class="secondary-font">Souscription</h4>
            <span v-if="souscription?.actif" class="tag-state success ml-4">Active</span>
            <span v-else class="tag-state ml-4">Inactive</span>
          </div>
          <h6 class="secondary-font text-primary-color mb-4">
            {{ souscription ? 'Valable jusqu\'au ' + formatDateFrench(souscription.date_fin) : '-' }}
          </h6>
          <h2 class="secondary-font">
            {{ userPhone || '-' }}
          </h2>
        </div>
      </div>
    </aside>

    <section class="app-section">
      <div class="page-space-40" />

      <div class="sidebar-icon open show-mobile mb-5" @click="toggleSidebar">
        <div class="barr1" />
        <div class="barr2" />
        <div class="barr3" />
      </div>
      <div class="page-space-50">
      <router-view />
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import authService from '@/services/authService'
import { useSubscriptionStore } from '@/stores/subscription.store'
import { useProfileStore } from '@/stores/profile.store'
import { useWalletStore } from '@/stores/wallet.store'
import { useCarteStore } from '@/stores/carte.store'
import { formatDateFrench } from '@/utils/formatters'

export default defineComponent({
  name: 'FrontofficeProfil',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const subscriptionStore = useSubscriptionStore()
    const sidebarOpen = ref(true)
    const userPhone = ref('')

    const souscription = computed(() => subscriptionStore.souscription)

    const isGerant = computed(() => {
      const u = authService.getCurrentUser()
      return !!u?.is_gerant
    })

    const isActiveRoute = (path: string) => {
      if (path === '/front/profil') {
        return route.path === path
      }
      return route.path.startsWith(path)
    }

    const toggleSidebar = () => {
      sidebarOpen.value = !sidebarOpen.value
    }

    const handleLogout = async () => {
      try {
        await authService.logout()
      } catch (e) {
        // silencieux
      }
      // Reset all stores
      useProfileStore().$reset()
      subscriptionStore.$reset()
      useWalletStore().$reset()
      useCarteStore().$reset()
      localStorage.clear()
      sessionStorage.clear()
      router.push('/auth/sign-in')
    }

    let removeAfterHook: (() => void) | null = null

    onMounted(async () => {
      removeAfterHook = router.afterEach(() => {
        if (window.innerWidth <= 1024) {
          sidebarOpen.value = false
        }
      })

      const user = authService.getCurrentUser()
      if (user) {
        userPhone.value = user.telephone || ''
      }
      try {
        await subscriptionStore.fetchSouscription()
      } catch (e) {
        // silencieux - le widget ne s'affichera pas
      }
    })

    onBeforeUnmount(() => {
      if (removeAfterHook) {
        removeAfterHook()
      }
    })

    return {
      sidebarOpen,
      toggleSidebar,
      handleLogout,
      isActiveRoute,
      souscription,
      userPhone,
      formatDateFrench,
      isGerant
    }
  }
})
</script>

<style scoped>
/* Les styles de la sidebar sont déjà définis globalement dans user-ui.css */
</style>
